'use client';

import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Card } from '@/components/ui/card';
import { MessageCircle } from 'lucide-react';
import { faqs } from '@/lib/mock-data';

export function FAQSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0f0f0f] to-[#1a1a1a]">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#5865F2]/10 border border-[#5865F2]/20 mb-6">
            <MessageCircle className="h-5 w-5 text-[#5865F2]" />
            <span className="text-sm font-semibold text-[#5865F2]">FREQUENTLY ASKED</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Got Questions?
          </h2>
          <p className="text-xl text-[#b9bbbe] max-w-2xl mx-auto">
            Find answers to common questions about Yokki
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Card className="bg-[#1a1a1a] border-[#b9bbbe]/10 p-6">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                >
                  <AccordionItem
                    value={`item-${index}`}
                    className="border-[#b9bbbe]/10 bg-[#252525] rounded-lg px-6 data-[state=open]:bg-[#2a2a2a]"
                  >
                    <AccordionTrigger className="text-white hover:text-[#5865F2] text-left py-6 text-lg font-semibold hover:no-underline">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#b9bbbe] pb-6 leading-relaxed">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                </motion.div>
              ))}
            </Accordion>
          </Card>

          {/* Contact support CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12 text-center"
          >
            <p className="text-[#b9bbbe] mb-4">
              Still have questions? Join our support server!
            </p>
            <a
              href="https://discord.gg/BZkDrjG2"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#5865F2] hover:bg-[#4752C4] text-white rounded-lg font-semibold transition-colors"
            >
              <MessageCircle className="h-5 w-5" />
              Join Support Discord
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
